import instantsearch from "instantsearch.js/es";
import {
  connectClearRefinements,
  connectCurrentRefinements,
  connectGeoSearch,
  connectHits,
  connectMenu,
  connectPagination,
  connectRefinementList,
  connectSearchBox,
  connectStats,
} from "instantsearch.js/es/connectors";
import connectCustomRange from "./connectCustomRange";
import history from "instantsearch.js/es/lib/routers/history";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import { configure, refinementList, stats } from "instantsearch.js/es/widgets";

import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";

import "leaflet-responsive-popup";

import { searchClient } from "./searchClient";
import { regions } from "./regions";
import { districts } from "./districts";
import { suburbs } from "./suburbs";

import debounce from "lodash.debounce";

const sendEventDebounced = debounce((uiState) => {
  gtag("event", "page_view", {
    page_location: window.location.pathname + window.location.search,
  });
  document.querySelector("#save-search-return").value = btoa(
    window.location.href
  );

  if (typeof googletag !== "undefined") {
    googletag.cmd.push(function () {
      googletag.pubads().refresh();
    });
  }
}, 1000);

const indexName = "prod_LISTINGS";
const regionFacet = [];
const districtFacet = [];
const suburbFacet = [];
const categoryFacet = [];

let bounds = null;
let map = null;
let isUserInteraction = true;
let loaded = false;
let markersRef = {};
let markers = null;
let mapMove = true;
let mobileTransition = false;
let loadingComplete = true;

let categoryChanged = true;
let tagChanged = true;
let amenityChanged = true;
let districtChanged = false;
let searchChanged = false;
let userChanged = false;
let idChanged = false;
let searchBoxEmpty = true;
let categorySelected = "";
let tag = "";
let amenitiesSelected = "";
let idSelected = "";
let userSelected = "";
let searchBox = "";
let title = "";
let regionSelected = "";
let districtSelected = "";
let suburbSelected = "";
let categorySaved = "";
let regionSaved = "";
let districtSaved = "";
let suburbSaved = "";

const encodedCategories = {
  "office-space": "Office Space",
  "retail-space": "Retail Space",
  "carpark-space": "Car Park Space",
  "event-space": "Event Space",
  "storage-space": "Storage Space",
  "studio-space": "Studio Space",
  "meeting-space": "Meeting Space",
  "commercial-kitchen": "Commercial Kitchens",
  "shoot-location": "Shoot Location",
};

const encodedRegions = regions;

const encodedDistricts = districts;

const encodedSuburbs = suburbs;

const decodedCategories = Object.keys(encodedCategories).reduce((acc, key) => {
  const newKey = encodedCategories[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

const decodedRegions = Object.keys(encodedRegions).reduce((acc, key) => {
  const newKey = encodedRegions[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

const decodedDistricts = Object.keys(encodedDistricts).reduce((acc, key) => {
  const newKey = encodedDistricts[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

const decodedSuburbs = Object.keys(encodedSuburbs).reduce((acc, key) => {
  const newKey = encodedSuburbs[key];
  const newValue = key;

  return {
    ...acc,
    [newKey]: newValue,
  };
}, {});

// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getCategorySlug(name) {
  const encodedName = decodedCategories[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

function getRegionSlug(name) {
  const encodedName = decodedRegions[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

function getDistrictSlug(name) {
  const encodedName = decodedDistricts[name] || name;

  return encodedName.split(" ").map(encodeURIComponent).join("+");
}

function getSuburbSlug(name) {
  const encodedName = decodedSuburbs[name] || name;

  if (!Array.isArray(encodedName)) {
    return encodedName.split(" ").map(encodeURIComponent).join("+");
  }
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
  const decodedSlug = encodedCategories[slug] || "";

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

function getRegionName(slug) {
  const decodedSlug = encodedRegions[slug] || slug;

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

function getDistrictName(slug) {
  const decodedSlug = encodedDistricts[slug] || slug;

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

function getSuburbName(slug) {
  const decodedSlug = encodedSuburbs[slug] || slug;

  return decodedSlug.split("+").map(decodeURIComponent).join(" ");
}

String.prototype.format =
  String.prototype.format ||
  function () {
    "use strict";
    var str = this.toString();
    if (arguments.length) {
      var t = typeof arguments[0];
      var key;
      var args =
        "string" === t || "number" === t
          ? Array.prototype.slice.call(arguments)
          : arguments[0];

      for (key in args) {
        str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), args[key]);
      }
    }

    return str;
  };

export const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    router: history({
      windowTitle({
        category,
        region,
        district,
        suburb,
        query,
        space_type,
        amenities,
        user_id,
        id,
      }) {
        const queryTitle = query ? `"${query}"` : "Search Sharedspace";
        const emptySearchTitle =
          "Find or share office space, meeting rooms, event spaces, car parks and creative studios space - Sharedspace";
        const emptySearchDescription =
          "Sharedspace is NZ's marketplace for shared and short term space. Discover office space, meeting rooms, event spaces, car parks and creative studios.";

        const titles = {
          "Office Space": "{0}Office Space",
          "Event Space": "{0}Venues for hire and event spaces",
          "Car Park Space": "{0}Carpark space",
          "Commercial Kitchens": "{0}Commercial kitchen",
          "Meeting Space": "{0}Meeting Space",
          "Retail Space": "{0}Retail Space",
          "Shoot Location": "{0}Shoot Location",
          "Storage Space": "{0}Storage space",
          "Studio Space": "{0}Studio space",
        };

        const categoryTitle = {
          "Office Space":
            "{0}Office Space, Coworking Spaces and Shared Office Space for Rent",
          "Event Space": "{0}Venues for hire and event spaces",
          "Car Park Space": "{0}Carpark space for rent, hire, lease or share",
          "Commercial Kitchens":
            "{0}Commercial kitchens for hire or rent  around New Zealand",
          "Meeting Space":
            "{0}Meeting Rooms, Conference Spaces and Board Rooms for hire",
          "Retail Space":
            "{0}Retail spaces, shops for rent and retail space for lease or share",
          "Shoot Location": "{0}Film and shoot locations around New Zealand",
          "Storage Space":
            "{0}Storage units, storage spaces and self storage facilities",
          "Studio Space":
            "{0}Creative studio spaces. Art, photography and fitness studios for hire",
        };

        const categorySubTitle = {
          "Office Space":
            "Browse shared office space, coworking spaces or office space for rent.",
          "Event Space":
            "Connect directly with unique event spaces or venues for hire across New Zealand. Discover the perfect space for your next event, corporate function, wedding or Christmas party on NZ’s leading event space marketplace.",
          "Car Park Space":
            "Discover car parks for rent or lease across New Zealand.",
          "Commercial Kitchens": "Discover your next commercial kichen space.",
          "Meeting Space":
            "Discover your next meeting room for hire or conference space.",
          "Retail Space":
            "Discover shared retail spaces, shops for rent and pop up shops.",
          "Shoot Location": "Spaces available for film or photo shoots.",
          "Storage Space":
            "Find your next self storage space, storage units or storage facilities.",
          "Studio Space": "Discover creative spaces available by the hour.",
        };

        const categoryDescription = {
          "Office Space":
            " Share your {0}office space on Sharedspace. Browse shared office space for rent, coworking spaces and serviced offices on New Zealands leading shared workspace website.",
          "Event Space":
            "Find your perfect {0}event space, venues for hire or function space on Sharedspace.co.nz. Search hundreds of unique event spaces and venues across New Zealand.",
          "Car Park Space":
            "Find or share your {0}car park on Sharedspace. Browse car parks for rent, car parks for hire and car parks for lease.",
          "Commercial Kitchens":
            "Find or share {0}commercial kitchens for hire or rent around New Zealand",
          "Meeting Space":
            "Find or share your {0}meeting space on Sharedspace. Discover your perfect meeting room, boardroom or conference rooms for hire.",
          "Retail Space":
            "Find or share {0}retail space and shops for rent. Browse retail spaces for lease across New Zealand",
          "Shoot Location":
            "Find or share {0}film locations and shoot locations around New Zealand ",
          "Storage Space":
            "Find or share your {0}storage space on Sharedspace. Browse storage units and self storage facilities across New Zealand",
          "Studio Space":
            "Find or share your {0}creative studio space. Browse photography studios, art studios, fitness studios and creative spaces available by the hour.",
        };

        jQuery("#saved-search").find("svg").remove();
        jQuery("#saved-search")
          .prepend(`<svg class="animate-spin h-5 w-5 mr-3 text-default" viewBox="0 0 24 24">
                <circle class="opacity-0" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>  
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg> `);
        jQuery("#saved-search").prop("disabled", true);

        categorySaved = category;
        regionSaved = region;
        districtSaved = district;
        suburbSaved = suburb;

        ajax(
          "/components/com_listings/assets/savedsearch.php?task=check&category=" +
            category +
            "&subcategory=&region=" +
            region +
            "&district=" +
            district +
            "&suburb=" +
            suburb +
            "&keyword=" +
            query +
            "&" +
            document.querySelector("#token").name +
            "=1"
        ).then(function (html) {
          if (html.success == true) {
            document.getElementById("saved-search").innerHTML = html.message;
            jQuery("#saved-search").prop("disabled", true);
          } else {
            //Pop up modal explaining issue.
            jQuery("#saved-search").find("svg").addClass("hidden");
            jQuery("#saved-search").prop("disabled", false);
            jQuery("#saved-search > span").text("Save Search");
          }
        });

        document.querySelector("#map-toggle").classList.remove("md:hidden");
        document.querySelector("#category-section").classList.remove("hidden");
        document.querySelector("#category-menu").classList.add("hidden");
        document.querySelector("#tags").classList.remove("hidden");
        document.querySelector("#category-header").classList.add("hidden");
        document.querySelector("#overlay-button").classList.add("hidden");
        document.querySelector("#category-title").innerHTML = ``;
        document.querySelector("#category-description").innerHTML = ``;
        // Add filter display in here.

        if (query) {
          searchBoxEmpty = query ? false : true;
          searchBox = query;
        }

        if (space_type && space_type.length) {
          tag = `${space_type}`;
        }

        if (amenities && amenities.length) {
          amenitiesSelected = `${amenities}`;
        }

        if (user_id && user_id.length) {
          userSelected = `${user_id}`;
        }

        if (id && id.length) {
          idSelected = `${id}`;
        }

        if (category) {
          categorySelected = `${category.toLowerCase()}`;
          // Remove filter display in here.
          document.querySelector("#overlay-button").classList.remove("hidden");
          document.querySelector("#category-header").classList.remove("hidden");
        }

        category = category === undefined ? false : category;
        region = region === undefined ? false : region;
        district = district === undefined ? false : district;
        suburb = suburb === undefined ? false : suburb;
        amenities = amenities === undefined ? [] : amenities;
        space_type = space_type === undefined ? [] : space_type;

        document.querySelector("#people-container").classList.add("hidden");

        if (
          category == "Meeting Space" ||
          category == "Office Space" ||
          category == "Event Space"
        ) {
          document
            .querySelector("#people-container")
            .classList.remove("hidden");
        }

        if (
          (!category &&
            !region &&
            !district &&
            !suburb &&
            space_type &&
            !space_type.length &&
            amenities &&
            !amenities.length) ||
          (!category && region)
        ) {
          document.querySelector("#map-toggle").classList.add("md:hidden");
          document.querySelector("#category-section").classList.add("hidden");
          document.querySelector("#category-menu").classList.remove("hidden");
          document.querySelector("#tags").classList.add("hidden");
        }

        if (suburb) {
          suburbSelected = suburb;
          for (index in categoryDescription) {
            if (category == index) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(suburb + " ")
                );
            }
          }

          title = "Search in " + suburb;
          document.querySelector("#location-label").innerHTML = suburb;
          document.querySelector(
            "#category-description"
          ).innerHTML = `${categorySubTitle[category]}`;

          for (index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(suburb + " ");
              document.querySelector("#category-title").innerHTML = `${title}`;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(suburb + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(suburb + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );

              return categoryTitle[index].format(suburb + " ");
            }
          }

          if (!category) {
            title = "Spaces available in " + suburb;
            regionSelected = region;
            districtSelected = district;
            return suburb + " spaces for rent, hire or share";
          }
        }

        if (district) {
          for (index in categoryDescription) {
            if (category == index) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(district + " ")
                );
            }
          }

          title = "Search in " + district;
          document.querySelector("#location-label").innerHTML = district;
          document.querySelector(
            "#category-description"
          ).innerHTML = `${categorySubTitle[category]}`;

          for (index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(district + " ");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(district + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(district + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format(district + " ");
            }
          }

          if (!category) {
            title = "Spaces available in " + district;
            regionSelected = region;
            districtSelected = "";
            suburbSelected = "";
            return district + " spaces for rent, hire or share";
          }
        }

        if (region) {
          for (index in categoryDescription) {
            if (category == index) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
            }
          }

          title = "Search in " + region;
          document.querySelector("#location-label").innerHTML = region;
          document.querySelector(
            "#category-description"
          ).innerHTML = `${categorySubTitle[category]}`;

          for (index in categoryTitle) {
            if (category == index) {
              title = titles[index].format(region + " ");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(region + " ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format(region + " ");
            }
          }

          if (!category) {
            title = "Spaces available in " + region;
            return region + " spaces for rent, hire or share";
          }
        }

        if (category) {
          for (index in categoryDescription) {
            if (category == index) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute("content", categoryDescription[index].format(""));
            }
          }

          title = category;
          document.querySelector(
            "#category-description"
          ).innerHTML = `${categorySubTitle[category]}`;

          if (document.querySelector("#statistic-category")) {
            document.querySelector(
              "#statistic-category"
            ).innerHTML = ` ${category} `;
          }

          for (index in categoryTitle) {
            if (category == index) {
              title = titles[index].format("");
              document.querySelector("#category-title").innerHTML = title;
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(" ")
                );
              document
                .querySelector('meta[property="twitter:title"]')
                .setAttribute("content", title);
              document
                .querySelector('meta[property="twitter:description"]')
                .setAttribute(
                  "content",
                  categoryDescription[index].format(" ")
                );
              document
                .querySelector('meta[property="og:image"]')
                .setAttribute(
                  "content",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              document
                .querySelector('link[rel="image_src"]')
                .setAttribute(
                  "href",
                  "https://assets.sharedspace.co.nz/images/categories/" +
                    getCategorySlug(category) +
                    ".jpg"
                );
              return categoryTitle[index].format("");
            }
          }
        }

        if (query) {
          document.querySelector("#map-toggle").classList.add("md:hidden");
          document.querySelector("#category-section").classList.add("hidden");
          document.querySelector("#category-menu").classList.remove("hidden");
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", emptySearchDescription);
          return emptySearchTitle;
        }

        document.getElementById("location-label").value = "Select a Location";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", emptySearchDescription);
        document.querySelector("#category-title").innerHTML = `${queryTitle}`;

        return emptySearchTitle;
      },

      createURL({ qsModule, routeState, location }) {
        document
          .querySelector('meta[property="og:url"]')
          .setAttribute("content", location.href);
        document
          .querySelector('meta[property="twitter:url"]')
          .setAttribute("content", location.href);
        const urlParts = location.href.match(/^(.*?)\/listings/);
        const baseUrl = `${urlParts ? urlParts[1] : ""}/`;
        const canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute("href", location.href);
        }
        let breadcrumbCollection = [];
        breadcrumbCollection.push({
          "@type": "ListItem",
          position: 1,
          item: {
            "@id": "/",
            name: "Home",
          },
        });
        breadcrumbCollection.push({
          "@type": "ListItem",
          position: 2,
          item: {
            "@id": "/listings",
            name: "Sharedspace listings",
          },
        });

        const categoryPath = routeState.category
          ? `${getCategorySlug(routeState.category)}/`
          : "";

        const regionPath = routeState.region
          ? `${getRegionSlug(routeState.region)}/`
          : "";

        const districtPath = routeState.district
          ? `${getDistrictSlug(routeState.district)}/`
          : "";

        const suburbPath = routeState.suburb
          ? `${getSuburbSlug(routeState.suburb)}/`
          : "";

        const queryParameters = {};

        if (routeState.query) {
          queryParameters.query = encodeURIComponent(routeState.query);
        }
        if (routeState.geoSearch !== 1) {
          queryParameters.geoSearch = routeState.geoSearch;
        }
        if (routeState.page !== 1) {
          queryParameters.page = routeState.page;
        }
        if (routeState.space_type !== 1) {
          queryParameters.space_type = routeState.space_type;
        }
        if (routeState.amenities !== 1) {
          queryParameters.amenities = routeState.amenities;
        }
        if (routeState.lower_capacity_upper_capacity) {
          queryParameters.lower_capacity_upper_capacity = encodeURIComponent(
            routeState.lower_capacity_upper_capacity
          );
        }
        if (routeState.user_id !== 1) {
          queryParameters.user_id = routeState.user_id;
        }
        if (routeState.id !== 1) {
          queryParameters.id = routeState.id;
        }

        const queryString = qsModule.stringify(queryParameters, {
          addQueryPrefix: true,
          arrayFormat: "repeat",
        });

        if (categoryPath) {
          breadcrumbCollection.push({
            "@type": "ListItem",
            position: 3,
            item: {
              "@id": `/listings/${categoryPath}`,
              name: `${routeState.category}`,
            },
          });

          if (regionPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 4,
              item: {
                "@id": `/listings/${categoryPath}${regionPath}`,
                name: `${routeState.region}`,
              },
            });
          }

          if (districtPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 5,
              item: {
                "@id": `/listings/${categoryPath}${regionPath}${districtPath}`,
                name: `${routeState.district}`,
              },
            });
          }

          if (suburbPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 6,
              item: {
                "@id": `/listings/${categoryPath}${regionPath}${districtPath}${suburbPath}`,
                name: `${routeState.suburb}`,
              },
            });
          }
        } else {
          if (regionPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 3,
              item: {
                "@id": `/listings/${regionPath}`,
                name: `${routeState.region}`,
              },
            });
          }

          if (districtPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 4,
              item: {
                "@id": `/listings/${regionPath}${districtPath}`,
                name: `${routeState.district}`,
              },
            });
          }

          if (suburbPath) {
            breadcrumbCollection.push({
              "@type": "ListItem",
              position: 5,
              item: {
                "@id": `/listings/${regionPath}${districtPath}${suburbPath}`,
                name: `${routeState.suburb}`,
              },
            });
          }
        }

        let breadcrumb = {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: breadcrumbCollection,
        };

        document.querySelector("#sharedspace-ldjson-breadcrumb").innerHTML =
          JSON.stringify(breadcrumb);

        return `${baseUrl}listings/${categoryPath}${regionPath}${districtPath}${suburbPath}${queryString}`;
      },

      parseURL({ qsModule, location }) {
        const pathnameMatches = location.pathname.match(/listings\/(.*?)\/?$/);
        const splitPath = pathnameMatches ? pathnameMatches[1].split("/") : [];
        const category = getCategoryName((splitPath && splitPath[0]) || "");

        let region = getRegionName((splitPath && splitPath[1]) || "");

        let district = getDistrictName((splitPath && splitPath[2]) || "");

        let suburb = getSuburbName((splitPath && splitPath[3]) || "");

        if (category == "") {
          region = getRegionName((splitPath && splitPath[0]) || "");

          district = getDistrictName((splitPath && splitPath[1]) || "");

          suburb = getSuburbName((splitPath && splitPath[2]) || "");
        }

        let {
          query = "",
          geoSearch,
          page,
          space_type,
          amenities,
          lower_capacity_upper_capacity,
          user_id,
          id,
        } = qsModule.parse(location.search.slice(1));

        // `qs` does not return an array when there's a single value.
        amenities = Array.isArray(amenities)
          ? amenities
          : [amenities].filter(Boolean);
        space_type = Array.isArray(space_type)
          ? space_type
          : [space_type].filter(Boolean);
        user_id = Array.isArray(user_id) ? user_id : [user_id].filter(Boolean);
        id = Array.isArray(id) ? id : [id].filter(Boolean);

        return {
          query: decodeURIComponent(query),
          page,
          geoSearch,
          suburb,
          region,
          district,
          category,
          lower_capacity_upper_capacity: decodeURIComponent(
            lower_capacity_upper_capacity
          ),
          space_type,
          amenities,
          user_id,
          id,
        };
      },
    }),

    stateMapping: {
      stateToRoute(uiState) {
        // refer to uiState docs for details: https://www.algolia.com/doc/api-reference/widgets/ui-state/js/
        return {
          query: uiState.prod_LISTINGS.query,
          lower_capacity_upper_capacity:
            uiState.prod_LISTINGS.range &&
            uiState.prod_LISTINGS.range.lower_capacity_upper_capacity,
          category:
            uiState.prod_LISTINGS.menu && uiState.prod_LISTINGS.menu.category,
          region:
            uiState.prod_LISTINGS.menu && uiState.prod_LISTINGS.menu.region,
          district:
            uiState.prod_LISTINGS.menu && uiState.prod_LISTINGS.menu.district,
          suburb:
            uiState.prod_LISTINGS.menu && uiState.prod_LISTINGS.menu.suburb,
          user_id:
            uiState.prod_LISTINGS.refinementList &&
            uiState.prod_LISTINGS.refinementList.user_id,
          id:
            uiState.prod_LISTINGS.refinementList &&
            uiState.prod_LISTINGS.refinementList.id,
          amenities:
            uiState.prod_LISTINGS.refinementList &&
            uiState.prod_LISTINGS.refinementList.amenities,
          space_type:
            uiState.prod_LISTINGS.refinementList &&
            uiState.prod_LISTINGS.refinementList.space_type,
          geoSearch: uiState.prod_LISTINGS.geoSearch,
          page: uiState.prod_LISTINGS.page,
        };
      },

      routeToState(routeState) {
        // refer to uiState docs for details: https://www.algolia.com/doc/api-reference/widgets/ui-state/js/
        return {
          // eslint-disable-next-line camelcase
          prod_LISTINGS: {
            query: routeState.query,
            menu: {
              category: routeState.category,
              region: routeState.region,
              district: routeState.district,
              suburb: routeState.suburb,
            },
            range: {
              lower_capacity_upper_capacity:
                routeState.lower_capacity_upper_capacity,
            },
            refinementList: {
              amenities: routeState.amenities,
              space_type: routeState.space_type,
              user_id: routeState.user_id,
              id: routeState.id,
            },
            geoSearch: routeState.geoSearch,
            page: routeState.page,
          },
        };
      },
    },
  },
});

const renderGeoSearch = async (renderOptions, isFirstRendering) => {
  const {
    items,
    currentRefinement,
    refine,
    clearMapRefinement,
    widgetParams,
    toggleRefineOnMapMove,
  } = renderOptions;

  const { initialZoom, initialPosition, container } = widgetParams;

  const searchMap = () => {
    jQuery("#saved-search").css("display", "hidden");
    const ne = map.wrapLatLng(map.getBounds().getNorthEast());
    const sw = map.wrapLatLng(map.getBounds().getSouthWest());

    if (ne.lng < 0 && sw.lng > 0) {
      refine({
        northEast: { lat: ne.lat, lng: 180 },
        southWest: { lat: sw.lat, lng: sw.lng },
      });
    } else {
      refine({
        northEast: { lat: ne.lat, lng: ne.lng },
        southWest: { lat: sw.lat, lng: sw.lng },
      });
    }
  };

  bounds = L.latLngBounds(
    items.map((item) => {
      return [item._geoloc.lat, item._geoloc.lng];
    })
  );

  if (isFirstRendering) {
    const element = document.createElement("div");
    element.style.height = "100%";

    const clearRefinementButton = document.createElement("div");
    clearRefinementButton.innerHTML = renderMapSearch;

    const enableMoveButton = document.createElement("div");
    enableMoveButton.innerHTML = activeMapMovement();

    map = L.map(element, { maxZoom: 20, zoomControl: false });

    L.tileLayer(
      "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
      {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 20,
      }
    ).addTo(map);

    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);

    map.on("popupopen", () => {
      isUserInteraction = false;
    });

    map.on("popupclose", () => {
      isUserInteraction = true;
    });

    window.addEventListener("popstate", (event) => {
      categoryChanged = true;
    });

    map.on("dragend", (e) => {
      if (isUserInteraction && mapMove) {
        document.getElementById("clearRegionRefinements").click();
        document.getElementById("clearDistrictRefinements").click();
        document.getElementById("clearSuburbRefinements").click();
        document.getElementById("location-label").innerHTML = "Location";
        searchMap();
      }

      if (!mapMove) {
        enableMoveButton.innerHTML = passiveMapMovement();
      }
    });

    map.on("zoomend", (e) => {
      if (isUserInteraction && mapMove && !mobileTransition) {
        document.getElementById("clearRegionRefinements").click();
        document.getElementById("clearDistrictRefinements").click();
        document.getElementById("clearSuburbRefinements").click();
        document.getElementById("location-label").innerHTML = "Location";
        searchMap();
      }

      if (!mapMove) {
        enableMoveButton.innerHTML = passiveMapMovement();
      }
    });

    enableMoveButton.addEventListener("click", () => {
      mapMove = !mapMove;

      if (mapMove) {
        document.getElementById("location-label").innerHTML = "Location";
        searchMap();
        enableMoveButton.innerHTML = activeMapMovement();
      }
    });

    container.appendChild(element);
    container.appendChild(enableMoveButton);

    document
      .getElementById("map-refinements")
      .appendChild(clearRefinementButton);

    document
      .querySelector("#map-search-close")
      .addEventListener("click", (event) => {
        event.stopPropagation();
        clearMapRefinement();
      });

    markers = L.markerClusterGroup({
      maxClusterRadius: function (zoom) {
        if (zoom >= 1 && zoom <= 2) {
          return 30;
        } else if (zoom >= 2 && zoom <= 4) {
          return 30;
        } else if (zoom >= 5 && zoom <= 8) {
          return 30;
        } else if (zoom >= 9 && zoom <= 13) {
          return 25;
        } else if (zoom >= 14 && zoom <= 18) {
          return 20;
        }
        return 15;
      },
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
      spiderfyOnMaxZoom: true,
      iconCreateFunction: function (cluster) {
        let iconSpiderSettings = {
          mapIconUrl: `<div class="cluster" title="" style="z-index: 1000001; cursor: pointer; width: 64px; height: 64px; user-select: none;">
                            <img alt="${cluster.getChildCount()}" aria-hidden="true" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5jYmltYWdlICgxKTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJjYmltYWdlLSgxKSIgZmlsbD0iI0FEQURBRCI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGwtb3BhY2l0eT0iMC4zIiBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMzIiIGN5PSIzMiIgcj0iMTYiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+" style="position: absolute;top: 0px;left: -16px;clip: rect(0px, 64px, 64px, 0px);width:64px;height: 64px">
                            <div aria-label="" tabindex="0" style="position: absolute;top: 0px;left: -16px;color: #fff;font-size: 14px;font-family: lato;font-weight: normal;font-style: normal;text-decoration: none;text-align: center;width: 64px;line-height: 64px">
                                <span aria-hidden="true">${cluster.getChildCount()}</span>
                            </div>
                        </div>`,
          cluster: cluster,
        };
        return L.divIcon({
          className: "leaflet-data-marker",
          html: L.Util.template(
            iconSpiderSettings.mapIconUrl,
            iconSpiderSettings
          ),
          iconAnchor: [12, 32],
          iconSize: [25, 30],
          popupAnchor: [0, -28],
        });
      },
    });
  }

  document.getElementById("map-refinements").classList.add("hidden");

  if (currentRefinement) {
    document.getElementById("map-refinements").classList.remove("hidden");
  }

  let listings = {};
  const watchlist = document
    .querySelector("#watchlist")
    .dataset.value.trim()
    .split(/\s*,\s*/);
  const user = document.querySelector("#user").dataset.value;

  if (
    (categorySelected && markers && categoryChanged) ||
    (markers && tagChanged) ||
    (markers && searchChanged) ||
    (markers && amenityChanged) ||
    (markers && userChanged) ||
    (markers && idChanged)
  ) {
    markers.clearLayers();
    markersRef = {};
  }

  markers.on("clustermouseover", function (event) {
    event.layer._icon.getElementsByTagName("img")[0].src =
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5jYmltYWdlICgxKTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJjYmltYWdlLSgxKSIgZmlsbD0iIzZFQzdDMCI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGwtb3BhY2l0eT0iMC4zIiBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMzIiIGN5PSIzMiIgcj0iMTYiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
  });

  markers.on("clustermouseout", function (event) {
    event.layer._icon.getElementsByTagName("img")[0].src =
      "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjRweCIgaGVpZ2h0PSI2NHB4IiB2aWV3Qm94PSIwIDAgNjQgNjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5jYmltYWdlICgxKTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJjYmltYWdlLSgxKSIgZmlsbD0iI0FEQURBRCI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGwtb3BhY2l0eT0iMC4zIiBjeD0iMzIiIGN5PSIzMiIgcj0iMzIiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMzIiIGN5PSIzMiIgcj0iMTYiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
  });

  if (!searchBoxEmpty && searchBox != "") {
    categoryChanged = true;
    userChanged = true;
    tagChanged = true;
    amenityChanged = true;
    renderMapMarkers(items);
  } else if (
    (categoryChanged ||
      tagChanged ||
      amenityChanged ||
      searchChanged ||
      userChanged ||
      idChanged) &&
    loadingComplete
  ) {
    categoryChanged = false;
    userChanged = false;
    idChanged = false;
    tagChanged = false;
    amenityChanged = false;
    searchChanged = false;
    loadingComplete = false;

    listings = ajax(
      "/components/com_listings/assets/mapsearch.php?category=" +
        categorySelected +
        "&tag=" +
        tag +
        "&amenities=" +
        amenitiesSelected +
        "&user=" +
        userSelected +
        "&id=" +
        idSelected
    )
      .then(function (items) {
        renderMapMarkers(items);
        loadingComplete = true;
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  isUserInteraction = false;

  if (!loaded && currentRefinement) {
    map.fitBounds(
      [
        [currentRefinement.northEast.lat, currentRefinement.northEast.lng],
        [currentRefinement.southWest.lat, currentRefinement.southWest.lng],
      ],
      {
        animate: false,
      }
    );
    loaded = true;
  }

  if (!currentRefinement && bounds.isValid()) {
    map.fitBounds(bounds, {
      animate: false,
      padding: [20, 20],
    });
  } else if (!currentRefinement) {
    map.setView(initialPosition, initialZoom, {
      animate: false,
      padding: [20, 20],
    });
  }
  isUserInteraction = true;
};

jQuery("#map-button").on("click", function () {
  jQuery("#map-view").removeClass("hidden");
  mobileTransition = true;
  map.invalidateSize();
  map.fitBounds(bounds, {
    animate: false,
  });
  jQuery("#listing-grid").addClass("hidden");
  jQuery("#list-button").removeClass();
  jQuery("#list-button").addClass(
    "shadow-lg relative inline-flex items-center py-3 px-6 rounded-l-full border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
  );
  jQuery(this).removeClass();
  jQuery(this).addClass(
    "shadow-lg -ml-px relative inline-flex items-center py-3 px-6 rounded-r-full border border-primary bg-primary text-sm font-medium text-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
  );
  mobileTransition = false;
});

jQuery("#list-button").on("click", function () {
  jQuery("#listing-grid").removeClass("hidden");
  jQuery("#map-view").addClass("hidden");
  jQuery("#map-button").removeClass();
  jQuery("#map-button").addClass(
    "shadow-lg relative inline-flex items-center py-3 px-6 rounded-r-full border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
  );
  jQuery(this).removeClass();
  jQuery(this).addClass(
    "shadow-lg -ml-px relative inline-flex items-center py-3 px-6 rounded-l-full border border-primary bg-primary text-sm font-medium text-white focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
  );
});

jQuery("#saved-search").on("click", function () {
  jQuery(this).find("svg").removeClass("hidden");
  jQuery(this).prop("disabled", true);
  ajax(
    "/components/com_listings/assets/savedsearch.php?task=savingsearch&user=" +
      document.querySelector("#user").dataset.value +
      "&section=1&category=" +
      categorySaved +
      "&subcategory=&region=" +
      regionSaved +
      "&district=" +
      districtSaved +
      "&suburb=" +
      suburbSaved +
      "&keyword=" +
      searchBox +
      "&" +
      document.querySelector("#token").name +
      "=1"
  ).then(function (html) {
    if (html.success == true) {
      jQuery("#saved-search > svg").addClass("hidden");
      document.getElementById("saved-search").innerHTML = html.message;
    } else {
      //Pop up modal explaining issue.
      jQuery("#saved-search > svg").addClass("hidden");
      jQuery("#saved-search").prop("disabled", false);
      jQuery("#login-modal").modal("show");
    }
  });
});

const activeMapMovement = () => {
  return `
        <div class="transform px-2 py-3 z-999 left-1 whitespace-nowrap absolute top-0">
            <label class="bg-white p-2 py-1.5 rounded-md inline-flex justify-center items-center shadow-lg border-gray-200 border">
                <input class="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" type="checkbox" checked>
                <span class="ml-2">Search as I move the map</span>
            </label>
        </div>
    `;
};

const passiveMapMovement = () => {
  return `
        <div class="transform px-2 py-3 z-999 left-1 whitespace-nowrap absolute top-0">
            <label class="bg-white p-2 py-1.5 rounded-md inline-flex justify-center items-center shadow-lg border-gray-200 border">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                </svg>
                <span class="ml-2">Search this area</span>
            </label>
        </div>
    `;
};

const renderMapMarkers = (items) => {
  const watchlist = document
    .querySelector("#watchlist")
    .dataset.value.trim()
    .split(/\s*,\s*/);
  const user = document.querySelector("#user").dataset.value;
  items.forEach((item, index) => {
    let url = `/listings/detail/${item.category
      .replace(/ +/g, "-")
      .toLowerCase()}/${item.region.replace(/ +/g, "-").toLowerCase()}/${
      item.id
    }/${item.title
      .replace("-", "")
      .replace(/ +/g, "-")
      .replace(/  +/g, "-")
      .toLowerCase()}.html`;
    let image = item.image;
    let pathname = "/images/no-image.jpg";
    if (image != null) {
      pathname = new URL(image)?.pathname;
    }
    let popup = L.responsivePopup({
      autoPanPadding: [10, 10],
      hasTip: false,
    }).setContent(
      '<div class="relative">' +
        `<div class="relative">
                <div class="group block w-full aspect-w-10 aspect-h-7 rounded-t-sm bg-gray-100 overflow-hidden">
                    <a class="map-click-${item.id}" href="${url}/?objectID=${
          item.id
        }" ${checkMobile() ? `target="_self"` : `target="_blank"`}>
                        <img class="object-cover"
                        src="https://assets.sharedspace.co.nz/cdn-cgi/image/height=350,quality=90,format=auto${pathname}" 
                        alt="${item.title}"
                        />
                    </a>
                </div>
                <span class="absolute top-2 right-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                    ${item.category}
                </span>
                <div class="absolute bottom-0 px-3 py-2 flex justify-between items-center">
                    <div class="flex items-center">
                        ${
                          user
                            ? `
                            ${
                              watchlist && watchlist.includes(item.id)
                                ? `
                                <div class="watchlist cursor-pointer" id="watchlist${index}" onClick="add_wl('watchlist${index}', '${item.id}', '${user}')">    
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.305 1.993C.305.893 1.198 0 2.297 0h11.016c1.1 0 1.992.893 1.992 1.993v16.796c0 1.1-.647 1.38-1.46.612 0 0-5.796-5.523-6.18-5.523-.383 0-5.939 5.507-5.939 5.507-.785.771-1.421.504-1.421-.596V1.993Z" fill="#6EC7C0" fill-rule="evenodd"/>
                                    </svg>
                                </div>
                             `
                                : `
                                <div class="watchlist cursor-pointer" id="watchlist${index}" onClick="add_wl('watchlist${index}', '${item.id}', '${user}')">
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                    </svg>
                                </div>
                             `
                            } `
                            : `
                                <div class="watchlist" id="watchlist${index}">
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                    </svg>
                                </div>
                             `
                        }
                    </div>
                </div>
            </div>
            <div class="mt-2">
                <div class="text-base font-bold block text-gray-default px-3 truncate">
                    <a class="map-click-${item.id}" href="${url}/?objectID=${
          item.id
        }" ${checkMobile() ? `target="_self"` : `target="_blank"`}>${
          item.title
        }</a>
                </div>
                <div class="truncate block text-xs text-gray-400 pointer-events-none px-3">${
                  item.suburb
                } / ${item.category}</div>
            </div>
            <div class="flex justify-between px-3 py-3 pb-2">
                <div class="flex">
                    <div class="flex items-center">
                    ${
                      (item.capacity &&
                        typeof item.capacity !== "undefined" &&
                        item.capacity > 0) ||
                      typeof item.capacity != "number"
                        ? `<svg width="8" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m5.832 10.593-.23 2.445c-.063.669-.654 1.211-1.315 1.211H3.082c-.663 0-1.253-.545-1.315-1.21l-.23-2.446h-.26c-.663 0-1.084-.531-.94-1.19l.681-3.105c.145-.657.8-1.19 1.463-1.19h2.407c.664 0 1.318.531 1.463 1.19l.68 3.105c.144.657-.275 1.19-.938 1.19h-.261ZM3.685 4.499A1.816 1.816 0 0 1 1.88 2.67c0-1.01.807-1.829 1.804-1.829.996 0 1.803.819 1.803 1.829s-.807 1.828-1.803 1.828Zm.96 5.863c.052-.545.547-.987 1.103-.986h.046l-.617-2.813c-.022-.101-.188-.236-.289-.236H2.481c-.1 0-.267.136-.289.236l-.611 2.811h.045c.555 0 1.047.45 1.097.988l.241 2.56c.004.042.076.108.118.108h1.205c.043 0 .114-.065.118-.107l.24-2.56Zm-.96-7.082a.605.605 0 0 0 .6-.61c0-.336-.268-.609-.6-.609a.605.605 0 0 0-.602.61c0 .336.27.609.602.609Z" fill="#4A4A4A" fill-rule="evenodd"/></svg>
                        <span class="text-gray-700 ml-1">${item.capacity}</span>`
                        : ``
                    }
                    </div>
                    <div class="flex ml-2 items-center">
                    ${
                      (item.area &&
                        typeof item.area !== "undefined" &&
                        item.area > 0) ||
                      typeof item.area != "number"
                        ? `<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><g fill="#4A4A4A" fill-rule="evenodd"><path d="M8.038 11.812h4.366V3.28H3.986v4.43c.244-.106.514-.164.797-.164h1.412c1.105 0 2 .893 2 1.995v1.494c0 .275-.056.538-.157.777ZM2.784 4.06c0-1.104.885-1.999 1.997-1.999h6.828a2 2 0 0 1 1.998 2v6.97c0 1.104-.886 2-1.998 2H4.781a2 2 0 0 1-1.997-2v-6.97Zm1.202 4.705v3.047h3.007V8.765H3.986Z"/></g></svg>
                        <span class="text-gray-700 ml-1">${item.area}</span>`
                        : ``
                    }
                    </div>
                </div>
                <div class="leading-4">
                    <span class="text-gray-700 font-medium block">${
                      typeof item.formatted_price !== "undefined" && item.price
                        ? item.formatted_price
                        : "POA"
                    }</span>
                </div>
            </div>
        </div>`
    );

    let marker = L.marker([item._geoloc.lat, item._geoloc.lng], {
      icon: L.divIcon({
        className: "leaflet-data-marker",
        html: `<svg xmlns="http://www.w3.org/2000/svg" class="-ml-4 -mt-4 h-8 w-8" viewBox="0 0 20 20" fill="${
          item.gold ? "#EAB308" : "#6EC7C0"
        }" fill-opacity="0.9">
                      <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                      <circle fill="#fff" cy="9.048" cx="10" r="3"/>
                    </svg>`,
      }),
      id: item.id,
    }).bindPopup(popup, { closeButton: false });

    marker.on("click", function (e) {
      e.target.setIcon(
        L.divIcon({
          className: "leaflet-data-marker",
          html: `<svg xmlns="http://www.w3.org/2000/svg" class="-ml-4 -mt-4 h-8 w-8" viewBox="0 0 20 20" fill="${
            item.gold ? "#EAB308" : "#6EC7C0"
          }">
                      <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
                      <circle fill="#fff" cy="9.048" cx="10" r="3"/>
                    </svg>`,
        })
      );
    });

    markersRef[item.id] = marker;
    markers.addLayer(marker);
  });

  map.addLayer(markers);

  let clickedMarker = "";
  map.on("zoomend", function () {
    if (clickedMarker !== "" && map.getZoom() >= map.options.maxZoom) {
      clickedMarker.__parent.spiderfy();
      clickedMarker = "";
    }
  });
};

// Create the render function
const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams, sendEvent } = renderOptions;

  const watchlist = document
    .querySelector("#watchlist")
    .dataset.value.trim()
    .split(/\s*,\s*/);
  const user = document.querySelector("#user").dataset.value;
  const showMap = document.querySelector("#show-map-input").value;

  if (!isFirstRender) {
    document.querySelector("#listing-grid-view").innerHTML = "";
    document.querySelector("#tag-placeholder").classList.add("hidden");
    document
      .querySelector("#listing-grid-view")
      .classList.add(
        "sm:grid-cols-1",
        "md:grid-cols-2",
        "lg:grid-cols-2",
        "2xl:grid-cols-3"
      );
    for (let i = 0; i < 24; i++) {
      let li = document.createElement("li");
      if (i == 7) {
        li.classList.add("advertising", "space-y-2");
        li.innerHTML = `<div class="flex justify-center flex-wrap">
                        <div id='div-gpt-ad-1643764940109-0' style='min-width: 300px; min-height: 250px;'></div>
                        <div class="text-gray-400 text-xs w-full flex justify-center">Advertisement</div>
                        </div>`;
      } else if (i == 14) {
        li.classList.add("advertisting", "space-y-2");
        li.innerHTML = `<div class="flex justify-center flex-wrap">
                        <div id='div-gpt-ad-1643775030507-0' style='min-width: 300px; min-height: 250px;'></div>
                        <div class="text-gray-400 text-xs w-full flex justify-center">Advertisement</div>
                        </div>`;
      } else {
        li.classList.add("listing-hit", "empty-listing-hit", "space-y-2");
        li.innerHTML = `<div class="relative">
                      <div class="aspect-w-12 aspect-h-9 bg-gray-300"></div>
                      <span class="absolute top-2 right-2 inline-flex h-4 items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 w-1/3 bg-300 animate-pulse">
                      </span>
                    </div>
                    <div class="text-gray-400 p-0">
                        <h3 class="truncate text-base font-bold m-0 w-1/2 bg-gray-400 h-4 animate-pulse"></h3>
                        <div class="bg-gray-300 mt-1 h-4 w-1/3 animate-pulse"></div>
                    </div>`;
      }

      document.querySelector("#listing-grid-view").appendChild(li);
    }
    if (!hits.length) {
      let relatedItems = [];
      let listings = ajax(
        "/components/com_listings/assets/premiumlistings.php?region=" +
          regionSelected
      )
        .then(function (items) {
          relatedItems = items.map((item, index) => {
            let url = `/listings/detail/${item.category
              .replace(/ +/g, "-")
              .toLowerCase()}/${item.region
              .replace(/ +/g, "-")
              .toLowerCase()}/${item.id}/${item.title
              .replace("-", "")
              .replace(/ +/g, "-")
              .replace(/  +/g, "-")
              .toLowerCase()}.html`;
            let image = item.image;
            let pathname = new URL(image)?.pathname;
            return `<div class="relative">
                        <div class="relative">
                            <div class="aspect-w-12 aspect-h-9 ${
                              item.gold
                                ? "ring-2 ring-offset-0 ring-yellow-400 ring-opacity-50"
                                : ""
                            }">
                                <a href="${url}" target="_blank">
                                    <img 
                                    class="absolute inset-0 h-full w-full shadow-md object-cover"
                                    srcset="
                                        https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   320w,
                                        https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   640w,
                                        https://assets.sharedspace.co.nz/cdn-cgi/image/width=450,quality=90,format=auto${pathname}   1280w,
                                    "
                                    src="https://assets.sharedspace.co.nz/cdn-cgi/image/height=350,quality=90,format=auto${pathname}" 
                                    alt="${item.title}" />
                                </a>
                            </div>
                            ${
                              item.gold
                                ? '<span class="absolute top-2 left-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-400 text-white">Gold</span>'
                                : ""
                            }
                            <span class="absolute top-2 right-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                                ${item.category}
                            </span>
                            <div class="absolute w-full h-8 bottom-0 bg-opacity-50 px-2 py-2 flex justify-between hits-center select-none ${
                              item.gold ? "bg-yellow-400" : " bg-black"
                            }">
                                <div class="flex items-center">
                                    ${
                                      user
                                        ? `
                                        ${
                                          watchlist &&
                                          watchlist.includes(item.id)
                                            ? `
                                            <div class="watchlist cursor-pointer" id="watchlist${index}" onClick="add_wl('watchlist${index}', '${item.id}', '${user}')">    
                                                <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M.305 1.993C.305.893 1.198 0 2.297 0h11.016c1.1 0 1.992.893 1.992 1.993v16.796c0 1.1-.647 1.38-1.46.612 0 0-5.796-5.523-6.18-5.523-.383 0-5.939 5.507-5.939 5.507-.785.771-1.421.504-1.421-.596V1.993Z" fill="#6EC7C0" fill-rule="evenodd"/>
                                                </svg>
                                            </div>
                                         `
                                            : `
                                            <div class="watchlist cursor-pointer" id="watchlist${index}" onClick="add_wl('watchlist${index}', '${item.id}', '${user}')">
                                                <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                                </svg>
                                            </div>
                                         `
                                        } `
                                        : `
                                            <div class="watchlist" title="Login to add to Watchlist">    
                                                <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                                </svg>
                                            </div>
                                         `
                                    }
                                    <div class="flex ml-2 items-center">
                                        ${
                                          (item.formatted_capacity &&
                                            typeof item.formatted_capacity !==
                                              "undefined" &&
                                            item.capacity > 0) ||
                                          typeof item.capacity != "number"
                                            ? `<svg width="8" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m5.832 10.593-.23 2.445c-.063.669-.654 1.211-1.315 1.211H3.082c-.663 0-1.253-.545-1.315-1.21l-.23-2.446h-.26c-.663 0-1.084-.531-.94-1.19l.681-3.105c.145-.657.8-1.19 1.463-1.19h2.407c.664 0 1.318.531 1.463 1.19l.68 3.105c.144.657-.275 1.19-.938 1.19h-.261ZM3.685 4.499A1.816 1.816 0 0 1 1.88 2.67c0-1.01.807-1.829 1.804-1.829.996 0 1.803.819 1.803 1.829s-.807 1.828-1.803 1.828Zm.96 5.863c.052-.545.547-.987 1.103-.986h.046l-.617-2.813c-.022-.101-.188-.236-.289-.236H2.481c-.1 0-.267.136-.289.236l-.611 2.811h.045c.555 0 1.047.45 1.097.988l.241 2.56c.004.042.076.108.118.108h1.205c.043 0 .114-.065.118-.107l.24-2.56Zm-.96-7.082a.605.605 0 0 0 .6-.61c0-.336-.268-.609-.6-.609a.605.605 0 0 0-.602.61c0 .336.27.609.602.609Z" fill="#FFF" fill-rule="evenodd"/></svg>
                                        <span class="text-white ml-1">${item.formatted_capacity}</span>`
                                            : ``
                                        }
                                    </div>
                                    <div class="flex ml-2 items-center">
                                        ${
                                          (item.formatted_area &&
                                            typeof item.formatted_area !==
                                              "undefined" &&
                                            item.area > 0) ||
                                          typeof item.area != "number"
                                            ? `<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fill-rule="evenodd"><path d="M8.038 11.812h4.366V3.28H3.986v4.43c.244-.106.514-.164.797-.164h1.412c1.105 0 2 .893 2 1.995v1.494c0 .275-.056.538-.157.777ZM2.784 4.06c0-1.104.885-1.999 1.997-1.999h6.828a2 2 0 0 1 1.998 2v6.97c0 1.104-.886 2-1.998 2H4.781a2 2 0 0 1-1.997-2v-6.97Zm1.202 4.705v3.047h3.007V8.765H3.986Z"/></g></svg>
                                        <span class="text-white ml-1">${item.formatted_area}</span>`
                                            : ``
                                        }
                                    </div>
                                </div>
                                <div class="leading-4">
                                    <span class="text-white">${
                                      typeof item.formatted_price !==
                                      "undefined"
                                        ? item.formatted_price
                                        : "POA"
                                    }</span>
                                </div>
                            </div>
                        </div>
                        <div class="text-default p-0">
                            <h3 class="truncate text-base font-bold m-0">
                                <a class="listing-click-${
                                  item.id
                                }" href="${url}/?objectID=${item.id}&queryID=${
              item.__queryID
            }" ${checkMobile() ? `target="_self">` : `target="_blank">`}${
              item.title
            }</a>
                            </h3>
                            <div class="text-gray-400 text-sm">${
                              item.region
                            } - ${item.suburb}</div>
                        </div>
                    </div>`;
          });
          document.querySelector("#relatedItems").innerHTML =
            relatedItems.join("");
        })
        .catch(function (error) {
          console.log(error);
        });

      document.querySelector("#category-header").classList.remove("hidden");
      document.querySelector("#category-section").classList.remove("hidden");
      document.querySelector("#category-header h1").innerHTML = title;
      return (widgetParams.container.innerHTML = `<ul role="list" id="listing-grid-view" class="listings-grid space-y-12 grid-cols-1 sm:grid sm:gap-x-6 sm:gap-y-6 sm:space-y-0 lg:gap-x-6">
                <li class="text-center mb-2"> Looks like we can't find any listings for your current search.</li>
                <li class="text-center mb-2"> Refine your search or browse below for spaces in your region.</li>
            </ul>
            <div id="relatedItems" class="mt-8 listings-grid space-y-12 grid-cols-1 sm:grid sm:gap-x-6 sm:gap-y-6 sm:space-y-0 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-3 lg:gap-x-6">
            </div>
            <div class="flex justify-center flex-wrap mt-4">
                <div id='div-gpt-ad-1643775030507-0' style='min-width: 300px; min-height: 250px;'></div>
                <div class="text-gray-400 text-xs w-full flex justify-center">Advertisement</div>
                <script>
                    googletag.cmd.push(function() { googletag.display('div-gpt-ad-1643775030507-0'); });
                </script>
            </div>`);
    }
  }

  if (hits.length) {
    let itemCollection = [];

    if (document.querySelector("#relatedItems")) {
      document.querySelector("#relatedItems").remove();
    }
    let listings = document.getElementsByClassName("listing-hit");
    for (let i = 0; i < hits.length; i++) {
      let url = `/listings/detail/${hits[i].category
        .replace(/ +/g, "-")
        .toLowerCase()}/${hits[i].region.replace(/ +/g, "-").toLowerCase()}/${
        hits[i].id
      }/${hits[i].title
        .replace("-", "")
        .replace(/ +/g, "-")
        .replace(/  +/g, "-")
        .toLowerCase()}.html`;
      let image = hits[i].image;
      let pathname = new URL(image)?.pathname;

      itemCollection.push({
        "@type": "ItemPage",
        name: `${hits[i].title}`,
        url: `${url}/?objectID=${hits[i].id}&queryID=${hits[i].__queryID}`,
      });

      listings[i].classList.remove("empty-listing-hit");
      listings[i].innerHTML = `<div id="${hits[i].id}" data-price="${
        typeof hits[i].price !== "undefined" ? hits[i].price : "POA"
      }">
            <div class="relative">
                <div class="aspect-w-12 aspect-h-9 ${
                  hits[i].plainum
                    ? "ring-2 ring-offset-0 ring-yellow-400 ring-opacity-50"
                    : ""
                }">
                    <a class="listing-click-${
                      hits[i].id
                    }" href="${url}/?objectID=${hits[i].id}&queryID=${
        hits[i].__queryID
      }" ${checkMobile() ? `target="_self">` : `target="_blank">`}
                        <img 
                            class="absolute inset-0 h-full w-full shadow-md object-cover"
                            srcset="
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   320w,
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=320,quality=90,format=auto${pathname}   640w,
                                https://assets.sharedspace.co.nz/cdn-cgi/image/width=450,quality=90,format=auto${pathname}   1280w,
                            "
                            src="https://assets.sharedspace.co.nz/cdn-cgi/image/width=450,quality=90,format=auto${pathname}" 
                            alt="${hits[i].title}" 
                        />
                    </a>
                </div>
                ${
                  hits[i].gold
                    ? '<span class="absolute top-2 left-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-400 text-white">Gold</span>'
                    : ""
                }
                <span class="absolute top-2 right-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                    ${hits[i].category}
                </span>
                <div class="absolute w-full h-8 bottom-0 bg-opacity-50 px-2 py-2 flex justify-between hits-center select-none ${
                  hits[i].gold ? "bg-yellow-400" : " bg-black"
                }">
                    <div class="flex items-center">
                        ${
                          user
                            ? `
                            ${
                              watchlist && watchlist.includes(hits[i].id)
                                ? `
                                <div class="watchlist cursor-pointer" id="watchlist${i}" onClick="add_wl('watchlist${i}', '${hits[i].id}', '${user}')">    
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.305 1.993C.305.893 1.198 0 2.297 0h11.016c1.1 0 1.992.893 1.992 1.993v16.796c0 1.1-.647 1.38-1.46.612 0 0-5.796-5.523-6.18-5.523-.383 0-5.939 5.507-5.939 5.507-.785.771-1.421.504-1.421-.596V1.993Z" fill="#6EC7C0" fill-rule="evenodd"/>
                                    </svg>
                                </div>
                             `
                                : `
                                <div class="watchlist cursor-pointer" id="watchlist${i}" onClick="add_wl('watchlist${i}', '${hits[i].id}', '${user}')">
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                    </svg>
                                </div>
                             `
                            } `
                            : `
                                <div class="watchlist" title="Login to add to Watchlist">    
                                    <svg width="16" height="20" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M.905 19.073H.901a.304.304 0 0 0 .01-.005Zm.159-.102c.041-.032.086-.072.134-.12l.24-.237a275.306 275.306 0 0 1 2.595-2.524l.155-.148c2.413-2.306 2.981-2.814 3.478-2.814.488 0 1.089.519 3.587 2.818l.154.142a262.901 262.901 0 0 1 2.704 2.532l.248.236c.136.128.22.185.242.216-.06-.014-.046-.107-.046-.283V1.993c0-.686-.557-1.243-1.242-1.243H2.297c-.685 0-1.242.557-1.242 1.243v16.796c0 .068.003.13.009.182Zm6.338-4.394a.766.766 0 0 0 .01.006Z" fill="#000" stroke="#FFF" stroke-width="1.5" fill-rule="evenodd" fill-opacity=".2"/>
                                    </svg>
                                </div>
                             `
                        }
                        <div class="flex ml-2 items-center">
                            ${
                              (hits[i].formatted_capacity &&
                                typeof hits[i].formatted_capacity !==
                                  "undefined" &&
                                hits[i].capacity > 0) ||
                              typeof hits[i].capacity != "number"
                                ? `<svg width="8" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m5.832 10.593-.23 2.445c-.063.669-.654 1.211-1.315 1.211H3.082c-.663 0-1.253-.545-1.315-1.21l-.23-2.446h-.26c-.663 0-1.084-.531-.94-1.19l.681-3.105c.145-.657.8-1.19 1.463-1.19h2.407c.664 0 1.318.531 1.463 1.19l.68 3.105c.144.657-.275 1.19-.938 1.19h-.261ZM3.685 4.499A1.816 1.816 0 0 1 1.88 2.67c0-1.01.807-1.829 1.804-1.829.996 0 1.803.819 1.803 1.829s-.807 1.828-1.803 1.828Zm.96 5.863c.052-.545.547-.987 1.103-.986h.046l-.617-2.813c-.022-.101-.188-.236-.289-.236H2.481c-.1 0-.267.136-.289.236l-.611 2.811h.045c.555 0 1.047.45 1.097.988l.241 2.56c.004.042.076.108.118.108h1.205c.043 0 .114-.065.118-.107l.24-2.56Zm-.96-7.082a.605.605 0 0 0 .6-.61c0-.336-.268-.609-.6-.609a.605.605 0 0 0-.602.61c0 .336.27.609.602.609Z" fill="#FFF" fill-rule="evenodd"/></svg>
                            <span class="text-white ml-1">${hits[i].formatted_capacity}</span>`
                                : ``
                            }
                        </div>
                        <div class="flex ml-2 items-center">
                            ${
                              (hits[i].formatted_area &&
                                typeof hits[i].formatted_area !== "undefined" &&
                                hits[i].area > 0) ||
                              typeof hits[i].area != "number"
                                ? `<svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fill-rule="evenodd"><path d="M8.038 11.812h4.366V3.28H3.986v4.43c.244-.106.514-.164.797-.164h1.412c1.105 0 2 .893 2 1.995v1.494c0 .275-.056.538-.157.777ZM2.784 4.06c0-1.104.885-1.999 1.997-1.999h6.828a2 2 0 0 1 1.998 2v6.97c0 1.104-.886 2-1.998 2H4.781a2 2 0 0 1-1.997-2v-6.97Zm1.202 4.705v3.047h3.007V8.765H3.986Z"/></g></svg>
                            <span class="text-white ml-1">${hits[i].formatted_area}</span>`
                                : ``
                            }
                        </div>
                    </div>
                    <div class="leading-4">
                        <span class="text-white">${
                          typeof hits[i].formatted_price !== "undefined"
                            ? hits[i].formatted_price
                            : "POA"
                        }</span>
                    </div>
                </div>
            </div>
            <div class="text-default p-0">
                <h3 class="truncate text-base font-bold m-0">
                    <a class="listing-click-${
                      hits[i].id
                    }" href="${url}/?objectID=${hits[i].id}&queryID=${
        hits[i].__queryID
      }" ${checkMobile() ? `target="_self">` : `target="_blank">`}${
        hits[i].title
      }</a>
                </h3>
                <div class="text-gray-400 text-sm">${hits[i].region} - ${
        hits[i].suburb
      }</div>
            </div>
        </div>`;

      var listingLink = document.getElementsByClassName(
        `listing-click-${hits[i].id}`
      );

      for (let i = 0; i < listingLink.length; i++) {
        listingLink[i].addEventListener("click", function () {
          sendEvent("click", hits[i], "Listing Clicked");
        });
      }
    }

    let collection = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      accessMode: "auditory, tactile, textual, visual, textOnVisual",
      publisher: "Sharedspace",
      mainEntity: {
        "@type": "ItemList",
        itemListElement: itemCollection,
      },
    };

    document.querySelector("#sharedspace-ldjson").innerHTML =
      JSON.stringify(collection);

    let elements = document.getElementsByClassName("empty-listing-hit");

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }
};

const renderPagination = (renderOptions, isFirstRender) => {
  const {
    pages,
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    refine,
    createURL,
  } = renderOptions;

  const container = document.querySelector("#pagination");

  container.innerHTML = `
        <nav class="border-t border-gray-200 px-4 flex items-center justify-between sm:px-0">
        ${
          !isFirstPage
            ? `
                <div class="-mt-px w-0 flex-1 flex">
                    <a href="${createURL(currentRefinement - 1)}" data-value="${
                currentRefinement - 1
              }" class="cursor-pointer border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300">
                    <!-- Heroicon name: solid/arrow-narrow-left -->
                    <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                    </svg>
                    Previous
                    </a>
                </div>
                `
            : ""
        }
        <div class="hidden md:-mt-px md:flex">
        ${pages
          .map(
            (page) => `
                <a href="${createURL(page)}" data-value="${page}" class="${
              currentRefinement === page
                ? "border-primary text-primary"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            } cursor-pointer border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium" >
                    ${page + 1}
                </a>
            `
          )
          .join("")}
            </div>
            ${
              !isLastPage
                ? `
                <div class="-mt-px w-0 flex-1 flex justify-end">
                    <a
                        href="${createURL(currentRefinement + 1)}"
                        data-value="${currentRefinement + 1}"
                        class="cursor-pointer border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    >
                    Next
                    <svg class="ml-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                    </a>
                </div>
                `
                : ""
            }
        </div>
    `;

  [...container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0 });
      refine(event.currentTarget.dataset.value);
    });
  });
};

const renderMenu = (renderOptions, isFirstRender) => {
  const {
    items,
    refine,
    createURL,
    isShowingMore,
    canToggleShowMore,
    toggleShowMore,
    widgetParams,
  } = renderOptions;

  const categoryIcons = {
    "Office Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/office-space.svg" alt="Office Space category" />',
    "Meeting Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/meeting-space.svg" alt="Meeting Space category" />',
    "Event Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/event-space.svg" alt="Event Space category" />',
    "Studio Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/studio-space.svg" alt="Studio Space category" />',
    "Car Park Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/carpark-space.svg" alt="Carpark Space category" />',
    "Commercial Kitchens":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/commercial-kitchen.svg" alt="Commercial Kitchen category" />',
    "Shoot Location":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/shoot-location.svg" alt="Shoot Location category" />',
    "Storage Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/storage-space.svg" alt="Storage Space category" />',
    "Retail Space":
      '<img style="width: 31px;" src="https://assets.sharedspace.co.nz/images/svgs/retail-space.svg" alt="Retail Space category" />',
  };

  if (!isFirstRender) {
    document.querySelector("#category-menu > div").innerHTML = "";
    for (let i = 0; i < 9; i++) {
      let div = document.createElement("div");
      div.classList.add("category", "empty-category", "text-center", "px-2");
      div.innerHTML = `<div class="image flex justify-center">
                <div class="h-12 bg-gray-300 w-14 object-cover object-center"></div>
              </div>
              <h5 class="mx-auto w-1/2 h-2 animate-pulse bg-gray-300 mt-2">
              </h5>`;
      document.querySelector("#category-menu > div").appendChild(div);
    }
    if (!items.length) {
      return (widgetParams.container.innerHTML = `<div>
            <div class="category text-center px-2">No menu options available</div></div>`);
    }
  }

  if (items.length) {
    let menus = document.getElementsByClassName("category");
    for (let i = 0; i < menus.length; i++) {
      if (items[i]) {
        menus[i].classList.remove("empty-category");
        menus[i].innerHTML = `
            <a data-value="${items[i].value}" href="${createURL(
          items[i].value
        )}">
                <div class="image flex justify-center mb-2">
                    ${categoryIcons[items[i].label]}
                </div>
                <h5 class="text-xs">
                    ${items[i].label}
                </h5>
            </a>`;
      }
    }

    let elements = document.getElementsByClassName("empty-category");

    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }

    [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();

        if (widgetParams.attribute == "category") {
          document.getElementById("clearTagRefinements").click();
          document.getElementById("clearAmenityRefinements").click();
          document.getElementById("clearCapacityRefinements").click();
          tag = "";
          tagChanged = true;
          amenitiesSelected = "";
          amenityChanged = true;
          userSelected = "";
          userChanged = true;
          idSelected = "";
          idChanged = true;
          categorySelected = event.currentTarget.dataset.value;
          categoryChanged = true;
        }

        refine(event.currentTarget.dataset.value);
      });
    });
  }
};

// Create the render function
const renderMenuCategorySelect = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = `
        <div id="${
          widgetParams.attribute
        }Menu" class="relative inline-block text-left w-full sm:w-auto">
            <button data-toggle="dropdown" type="button" class="w-full justify-between sm:w-auto group inline-flex sm:justify-center text-sm font-medium text-gray-700 hover:text-gray-900 sm:pr-0 pr-4" aria-expanded="false">
                ${
                  categorySelected
                    ? '<span class="capitalize">' + categorySelected + "</span>"
                    : '<span class="capitalize">' + widgetParams.attribute
                }</span>

                <!-- Heroicon name: solid/chevron-down -->
                <svg class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>

            <div class="hidden dropdown-menu origin-top-left absolute left-0 mt-4 w-48 shadow-lg bg-white sm:-ml-2 ring-1 ring-black ring-opacity-5 focus:outline-none z-10 h-80 overflow-y-auto">
                <div class="py-1">
                    ${items
                      .map(
                        (item) =>
                          `<label for="filter-category-0" class="${
                            item.isRefined ? "bg-gray-100" : ""
                          } text-gray-default block px-5 py-2 text-sm hover:bg-gray-100 cursor-pointer" ${createDataAttribtues(
                            item
                          )}>
                                ${item.label}
                            </label>`
                      )
                      .join("")}
                </div>
            </div>
        </div>
    `;

  [...widgetParams.container.querySelectorAll("label")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const item = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      if (widgetParams.attribute == "category") {
        document.getElementById("clearTagRefinements").click();
        document.getElementById("clearAmenityRefinements").click();
        document.getElementById("clearCapacityRefinements").click();
        tag = "";
        tagChanged = true;
        amenitiesSelected = "";
        amenityChanged = true;
        userSelected = "";
        userChanged = true;
        idSelected = "";
        idChanged = true;
        if (categorySelected == item.value.toLowerCase()) {
          let element = document.querySelector("#category-menu > div");
          if (element !== null) {
            element.classList.remove("grid-cols-1", "sm:grid-cols-1");
            element.classList.add("grid-cols-3", "sm:grid-cols-9");
          }
          categorySelected = "";
        } else {
          categorySelected = item.value.toLowerCase();
        }
        categoryChanged = true;
      }

      refine(item.value);
      // Update canonical URL after tag removal
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute("href", window.location.href);
      }
    });
  });
};

// Create the render function
const renderMenuSelect = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, widgetParams } = renderOptions;

  if (!items.length) {
    return;
  }

  widgetParams.container.innerHTML = `
        <div id="${
          widgetParams.attribute
        }Menu" class="relative inline-block text-left w-full sm:w-auto">
            <button data-toggle="dropdown" type="button" class="w-full justify-between sm:w-auto group inline-flex sm:justify-center text-sm font-medium text-gray-700 hover:text-gray-900 sm:pr-0 pr-4" aria-expanded="false">
                <span class="capitalize">${widgetParams.attribute}</span>

                <!-- Heroicon name: solid/chevron-down -->
                <svg class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>

            <div class="hidden dropdown-menu origin-top-right absolute right-0 mt-4 w-full sm:w-48 shadow-lg bg-white sm:-ml-2 ring-1 ring-black ring-opacity-5 focus:outline-none z-10 h-80 overflow-y-auto">
                <div class="py-1">
                    ${items
                      .map(
                        (item) =>
                          `<label for="filter-category-0" class="${
                            item.isRefined ? "bg-gray-100" : ""
                          } text-gray-default block px-5 py-2 text-sm hover:bg-gray-100 cursor-pointer" ${createDataAttribtues(
                            item
                          )}>
                                ${item.label}
                            </label>`
                      )
                      .join("")}
                </div>
            </div>
        </div>
    `;

  [...widgetParams.container.querySelectorAll("label")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const target = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      let array = [];

      items.forEach((item) => {
        if (item.isRefined) {
          array.push(item.value);
        }
      });

      if (widgetParams.attribute == "amenities") {
        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          amenitiesSelected = array.join();
        } else {
          array.push(target.value);
          amenitiesSelected = array.join();
        }
        amenityChanged = true;
      }

      if (widgetParams.attribute == "space_type") {
        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          tag = array.join();
        } else {
          array.push(target.value);
          tag = array.join();
        }
        tagChanged = true;
      }

      if (widgetParams.attribute == "user_id") {
        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          userSelected = array.join();
        } else {
          array.push(target.value);
          userSelected = array.join();
        }
        userChanged = true;
      }

      if (widgetParams.attribute == "id") {
        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          idSelected = array.join();
        } else {
          array.push(target.value);
          idSelected = array.join();
        }
        idChanged = true;
      }

      refine(target.value);
    });
  });
};

// Create the render function
const renderMenuLocationSelect = (renderOptions, isFirstRender) => {
  const { items, canRefine, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const select = document.createElement("select");

    select.addEventListener("change", (event) => {
      jQuery("#saved-search").css("display", "flex");

      document.getElementById("map-search-close").click();

      refine(event.target.value);

      if (widgetParams.attribute == "region") {
        if (districtChanged) {
          document.getElementById("clearDistrictRefinements").click();
          document.getElementById("clearSuburbRefinements").click();
          districtChanged = false;
        }
      }
    });

    widgetParams.container.appendChild(select);
  }

  if (widgetParams.attribute == "district") {
    items.forEach(function (item) {
      if (item.isRefined) {
        districtChanged = true;
      }
    });
  }

  const select = widgetParams.container.querySelector("select");
  select.classList.add("form-select");
  select.disabled = !canRefine;

  if (
    document.getElementById("regions").getElementsByTagName("select")[0]
      .value == "" &&
    widgetParams.attribute != "region"
  ) {
    select.disabled = true;
    select.innerHTML = `<option value="">See all</option>`;
    return;
  }

  if (widgetParams.attribute == "suburb") {
    if (
      document.getElementById("districts").getElementsByTagName("select")[0]
        .value == ""
    ) {
      select.disabled = true;
      select.innerHTML = `<option value="">See all</option>`;
      return;
    }
  }

  select.innerHTML = `
        <option value="">See all</option>
        ${items
          .map(
            (item) =>
              `<option
                    value="${item.value}"
                    ${item.isRefined ? "selected" : ""}
                >
                    ${item.label}
                </option>`
          )
          .join("")}
        `;
};

// Create the render function
const renderClearFilterRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear All";
    button.setAttribute("id", "clearFilterRefinements");
    button.classList.add("underline");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

// Create the render function
const renderClearRegionRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Region refinements";
    button.setAttribute("id", "clearRegionRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearDistrictRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear District refinements";
    button.setAttribute("id", "clearDistrictRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearSuburbRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Suburb refinements";
    button.setAttribute("id", "clearSuburbRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearTagRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Tag refinements";
    button.setAttribute("id", "clearTagRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      tag = "";
      tagChanged = true;
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearCapacityRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Capacity refinements";
    button.setAttribute("id", "clearCapacityRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

const renderClearAmenityRefinements = (renderOptions, isFirstRender) => {
  const { hasRefinements, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const button = document.createElement("button");
    button.textContent = "Clear Amenity refinements";
    button.setAttribute("id", "clearAmenityRefinements");

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      amenitiesSelected = "";
      amenityChanged = true;
      refine();
    });

    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("button").disabled = !hasRefinements;
};

// Create the render function
const createDataAttribtues = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(" ");

const renderListItem = (item) => `
    <div class="ml-2 sm:ml-2 my-1">
      <div class="-m-1 flex flex-wrap items-center">
        <span class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white">
          <span>
           ${item.refinements
             .map(
               (refinement) =>
                 `<h3 class="inline">${refinement.label}</h3>
                        <button type="button" class="flex-shrink-0 ml-1 h-4 w-4 p-1 mr-2 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500" ${createDataAttribtues(
                          refinement
                        )}>
                            <span class="sr-only">Remove filter for ${
                              refinement.label
                            }</span>
                            <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                              <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                            </svg>
                        </button>`
             )
             .join("")}
            </span>
        </span>
      </div>
    </div>
`;

const renderMapSearch = `
    <div class="mt-0 ml-2">
      <div class="-m-1 flex flex-wrap items-center">
        <span class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white">
          <span>
            Map Search
            <button type="button" id="map-search-close" class="flex-shrink-0 ml-1 h-4 w-4 p-1 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500">
                <span class="sr-only">Remove filter for Map Search</span>
                <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                  <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
                </svg>
            </button>
          </span>
        </span>
      </div>
    </div> 
`;

const renderStats = (renderOptions, isFirstRender) => {
  const {
    nbHits,
    areHitsSorted,
    hitsPerPage,
    nbSortedHits,
    page,
    processingTimeMS,
    query,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    return;
  }

  let count = "";
  if (nbHits > 1) {
    if ((page + 1) * hitsPerPage > nbHits) {
      count += `Showing ${
        page * hitsPerPage + 1
      } - ${nbHits} of ${nbHits} ${categorySelected.toLowerCase()} listings`;
    } else if (page >= 1) {
      count += `Showing ${page * hitsPerPage + 1} - ${
        (page + 1) * hitsPerPage
      } of ${nbHits} ${categorySelected.toLowerCase()} listings`;
    } else {
      count += `Showing 1 - ${
        (page + 1) * hitsPerPage
      } of ${nbHits} ${categorySelected.toLowerCase()} listings`;
    }
  } else if (nbHits === 1) {
    count += `Showing 1 ${categorySelected} listing`;
  } else {
    count += `Showing 0 ${categorySelected} listings`;
  }

  widgetParams.container.innerHTML = `${count}`;
};

const renderCustomRange = (renderOptions, isFirstRender) => {
  const { start, range, refine, widgetParams } = renderOptions;

  if (isFirstRender) {
    const input = document.createElement("input");
    input.type = "text";
    input.setAttribute("id", "input1");
    input.classList.add("form-input");
    const input2 = document.createElement("input");
    input2.type = "text";
    input2.setAttribute("id", "input2");
    input2.classList.add("form-input");

    widgetParams.container.appendChild(input);
    widgetParams.container.appendChild(input2);

    return;
  }
  let nonLinearSlider = document.getElementById("people");

  let min = Number.isFinite(start[0]) ? start[0] : range.min;
  let max = Number.isFinite(start[1]) ? start[1] : range.max;

  const input = widgetParams.container.querySelector("#input1");
  const input2 = widgetParams.container.querySelector("#input2");

  if (categorySelected == "office space") {
    let maxStart = Number.isFinite(start[1]) ? start[1] : range.max;
    max = 75;
    range.max = 75;
    if (maxStart <= 75) {
      max = maxStart;
    }
  }

  if (categorySelected == "event space") {
    let maxStart = Number.isFinite(start[1]) ? start[1] : range.max;
    max = 500;
    range.max = 500;
    if (maxStart <= 500) {
      max = maxStart;
    }
  }

  if (categorySelected == "meeting space") {
    let maxStart = Number.isFinite(start[1]) ? start[1] : range.max;
    max = 250;
    range.max = 250;
    if (maxStart < 250) {
      max = maxStart;
    }
  }

  if (
    nonLinearSlider.noUiSlider === undefined &&
    max > 0 &&
    range &&
    !isFirstRender
  ) {
    noUiSlider.create(nonLinearSlider, {
      start: [min, max],
      connect: true,
      format: {
        to: function (value) {
          return Number(value);
        },
        from: function (value) {
          return Number(value);
        },
      },
      range: {
        min: [range.min],
        max: [range.max],
      },
    });

    nonLinearSlider.noUiSlider.on("update", function (values, handle) {
      var value = values[handle];
      if (handle) {
        input2.value = Math.round(value);
      } else {
        input.value = Math.round(value);
      }
    });

    nonLinearSlider.noUiSlider.on("change", function (values, handle) {
      var value = values[handle];
      var event = new Event("change");
      if (handle) {
        input2.value = Math.round(value);
        input2.dispatchEvent(event);
      } else {
        input.value = Math.round(value);
        input.dispatchEvent(event);
      }
    });

    input.addEventListener("change", (event) => {
      nonLinearSlider.noUiSlider.set([event.target.value, null], false);
      refine([parseFloat(event.target.value), parseFloat(input2.value)]);
    });

    input2.addEventListener("change", (event) => {
      nonLinearSlider.noUiSlider.set([null, parseFloat(event.target.value)]);
      refine([parseFloat(input.value), parseFloat(event.target.value)]);
    });
  }

  if ((categoryChanged || userChanged || idChanged) && max > 0) {
    nonLinearSlider.noUiSlider.updateOptions({
      start: [min, max],
      range: {
        min: [range.min],
        max: [range.max],
      },
    });
  }

  input.value = min;
  input2.value = max;
};

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions;

  widgetParams.container.innerHTML = `
        ${items.map(renderListItem).join("")}
    `;

  [...widgetParams.container.querySelectorAll("button")].forEach((element) => {
    element.addEventListener("click", (event) => {
      const target = Object.keys(event.currentTarget.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: event.currentTarget.dataset[key],
        }),
        {}
      );

      if (event.currentTarget.dataset.attribute == "region") {
        document.getElementById("clearRegionRefinements").click();
        document.getElementById("clearDistrictRefinements").click();
        document.getElementById("clearSuburbRefinements").click();
        document.getElementById("location-label").innerHTML = "Location";
      }

      if (event.currentTarget.dataset.attribute == "district") {
        document.getElementById("clearDistrictRefinements").click();
        document.getElementById("clearSuburbRefinements").click();
      }

      if (event.currentTarget.dataset.attribute == "category") {
        let element = document.querySelector("#category-menu > div");
        if (element !== null) {
          element.classList.remove("grid-cols-1", "sm:grid-cols-1");
          element.classList.add("grid-cols-3", "sm:grid-cols-9");
        }

        document.getElementById("clearTagRefinements").click();
        document.getElementById("clearAmenityRefinements").click();
        document.getElementById("clearCapacityRefinements").click();
        categorySelected = "";
        categoryChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "amenities") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "amenities") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          amenitiesSelected = array.join();
        }
        amenityChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "space_type") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "space_type") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          tag = array.join();
        }
        tagChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "user_id") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "user_id") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          userSelected = array.join();
        }
        userChanged = true;
      }

      if (event.currentTarget.dataset.attribute == "id") {
        let array = [];

        items.forEach((item) => {
          if (item.attribute == "id") {
            item.refinements.forEach((refinement) => {
              array.push(refinement.value);
            });
          }
        });

        if (array.includes(target.value)) {
          array = array.filter(function (item) {
            return item !== target.value;
          });
          idSelected = array.join();
        }
        idChanged = true;
      }

      refine(target);
      // Update canonical URL after tag removal
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.setAttribute("href", window.location.href);
      }
    });
  });
};

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

  if (isFirstRender) {
    const input = document.createElement("input");
    input.setAttribute("class", "form-input-search");
    input.setAttribute("placeholder", "Search Space");

    const button = document.createElement("button");
    button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

    input.addEventListener("input", (event) => {
      if (event.target.value == "") {
        searchChanged = false;
        searchBoxEmpty = true;
        searchBox = "";
      } else {
        searchChanged = true;
        searchBoxEmpty = false;
        searchBox = event.target.value;
      }

      refine(event.target.value);
    });

    button.addEventListener("click", () => {
      searchBoxEmpty = true;
      clear();
    });

    widgetParams.container.appendChild(input);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("input").value = query;
};

const renderObjectIDRefinementList = (renderOptions, isFirstRender) => {
  const {
    items,
    isFromSearch,
    refine,
    createURL,
    isShowingMore,
    canToggleShowMore,
    searchForItems,
    toggleShowMore,
    widgetParams,
  } = renderOptions;

  if (isFirstRender) {
    const input = document.createElement("input");
    const ul = document.createElement("ul");
    input.setAttribute("class", "form-input mb-4");
    input.setAttribute("type", "text");
    input.setAttribute("placeholder", "Search Listing ID");

    input.addEventListener("input", (event) => {
      searchForItems(event.currentTarget.value);
    });

    widgetParams.container.appendChild(input);
    widgetParams.container.appendChild(ul);
  }

  const input = widgetParams.container.querySelector("input");

  if (!isFromSearch && input.value) {
    input.value = "";
  }

  widgetParams.container.querySelector("ul").innerHTML = items
    .map(
      (item) => `
                ${
                  item.value == input.value
                    ? `<li>
                    <a
                    href="${createURL(item.value)}"
                    data-value="${item.value}"
                    style="font-weight: ${item.isRefined ? "bold" : ""}"
                    >
                        ${item.label}
                    </a>
                </li>`
                    : ""
                }`
    )
    .join("");

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();
      refine(event.currentTarget.dataset.value);
    });
  });
};

const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, isShowingMore, toggleShowMore, refine, widgetParams } =
    renderOptions;

  if (isFirstRender) {
    const ul = document.createElement("ul");
    const button = document.createElement("button");
    button.textContent = "Show more";

    button.addEventListener("click", () => {
      toggleShowMore();
    });

    ul.classList.add("grid", "sm:grid-cols-2", "gap-2");
    button.classList.add("mt-4", "underline");

    widgetParams.container.appendChild(ul);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("ul").innerHTML = `
        ${items
          .map(
            (item) => `
                <div class="mt-2 divide-y divide-gray-200">
                    <div class="relative flex items-start py-1">
                        <a class="flex justify-between w-full"
                            data-value="${item.value}">
                            <div class="flex items-center h-5">
                                <input id="${item.label}" ${
              item.isRefined ? "checked" : ""
            } type="checkbox" class="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded">
                            </div>
                            <div class="ml-3 min-w-0 flex-1 text-sm">
                                <label for="${
                                  item.label
                                }" class="font-medium text-gray-700 select-none cursor-pointer">
                                    ${
                                      item.label.match(/[A-Z][a-z]+|[0-9]+/g)
                                        ? item.label
                                            .match(/[A-Z][a-z]+|[0-9]+/g)
                                            .join(" ")
                                        : item.label
                                    }
                                </label>
                            </div>
                        </a>
                    </div>
                </div>`
          )
          .join(" ")}
        `;

  widgetParams.container.querySelector("button").textContent = isShowingMore
    ? "Show less"
    : "Show more";

  widgetParams.container.querySelector("button").classList.add("hidden");

  if (items.length >= 5) {
    widgetParams.container.querySelector("button").classList.remove("hidden");
  }

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      let array = [];

      items.forEach((item) => {
        if (item.isRefined) {
          array.push(item.value);
        }
      });

      if (widgetParams.attribute == "space_type") {
        if (array.includes(event.currentTarget.dataset.value)) {
          array = array.filter(function (item) {
            return item !== event.currentTarget.dataset.value;
          });
          tag = array.join();
        } else {
          array.push(event.currentTarget.dataset.value);
          tag = array.join();
        }
        tagChanged = true;
      }

      if (widgetParams.attribute == "amenities") {
        if (array.includes(event.currentTarget.dataset.value)) {
          array = array.filter(function (item) {
            return item !== event.currentTarget.dataset.value;
          });
          amenitiesSelected = array.join();
        } else {
          array.push(event.currentTarget.dataset.value);
          amenitiesSelected = array.join();
        }
        amenityChanged = true;
      }

      refine(event.currentTarget.dataset.value);
    });
  });
};

const renderTagRefinementList = (renderOptions, isFirstRender) => {
  const { items, isShowingMore, toggleShowMore, refine, widgetParams } =
    renderOptions;

  if (isFirstRender) {
    const div = document.createElement("div");
    const button = document.createElement("button");
    button.textContent = "Show more";

    button.addEventListener("click", () => {
      toggleShowMore();
    });

    div.classList.add("flex", "gap-2", "flex-wrap");
    button.classList.add("underline", "flex", "flex-shrink-0", "ml-2");

    widgetParams.container.appendChild(div);
    widgetParams.container.appendChild(button);
  }

  widgetParams.container.querySelector("div").innerHTML = `
      ${items
        .map(
          (item) => `
                  <div class="my-1">
                    <div class="-m-1 flex flex-wrap items-center">
                      <a class="${
                        item.isRefined ? `text-white` : ``
                      } flex cursor-pointer whitespace-nowrap" data-value="${
            item.value
          }">
                        <span ${
                          item.isRefined
                            ? `class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 px-3 text-sm font-semibold bg-primary text-white"`
                            : `class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 px-3 text-sm font-medium bg-white"`
                        }>
                          <h3 class="inline">
                              ${item.label}
                          </h3>
                        </span>
                      </a>
                    </div>
                  </div>`
        )
        .join("")}`;

  widgetParams.container.querySelector("button").textContent = isShowingMore
    ? "Show less"
    : "Show more";

  widgetParams.container.querySelector("button").classList.add("hidden");

  if (items.length >= 5) {
    widgetParams.container.querySelector("button").classList.remove("hidden");
  }

  [...widgetParams.container.querySelectorAll("a")].forEach((element) => {
    element.addEventListener("click", (event) => {
      event.preventDefault();

      let array = [];

      items.forEach((item) => {
        if (item.isRefined) {
          array.push(item.value);
        }
      });

      if (array.includes(event.currentTarget.dataset.value)) {
        array = array.filter(function (item) {
          return item !== event.currentTarget.dataset.value;
        });
      } else {
        array.push(event.currentTarget.dataset.value);
      }

      refine(event.currentTarget.dataset.value);
    });
  });
};

const customGeoSearch = connectGeoSearch(renderGeoSearch);
const customHits = connectHits(renderHits);
const customMenu = connectMenu(renderMenu);
const customMenuSelect = connectMenu(renderMenuSelect);
const customRange = connectCustomRange(renderCustomRange);
const customMenuCategorySelect = connectMenu(renderMenuCategorySelect);
const customMenuLocationSelect = connectMenu(renderMenuLocationSelect);
const customClearFilterRefinements = connectClearRefinements(
  renderClearFilterRefinements
);
const customClearRegionRefinements = connectClearRefinements(
  renderClearRegionRefinements
);
const customClearDistrictRefinements = connectClearRefinements(
  renderClearDistrictRefinements
);
const customClearSuburbRefinements = connectClearRefinements(
  renderClearSuburbRefinements
);
const customClearTagRefinements = connectClearRefinements(
  renderClearTagRefinements
);
const customClearCapacityRefinements = connectClearRefinements(
  renderClearCapacityRefinements
);
const customClearAmenityRefinements = connectClearRefinements(
  renderClearAmenityRefinements
);
const customCurrentRefinements = connectCurrentRefinements(
  renderCurrentRefinements
);
const customPagination = connectPagination(renderPagination);
const customStats = connectStats(renderStats);
const customSearchBox = connectSearchBox(renderSearchBox);
const customRefinementList = connectRefinementList(renderRefinementList);
const customTagRefinementList = connectRefinementList(renderTagRefinementList);
const customObjectIDRefinementList = connectRefinementList(
  renderObjectIDRefinementList
);

searchClient
  .searchForFacetValues([
    {
      indexName,
      params: {
        facetName: "region",
        facetQuery: "",
      },
    },
  ])
  .then(([{ facetHits }]) => {
    regionFacet.push(
      ...facetHits.map((facet) => ({
        ...facet,
        label: facet.value,
        value: facet.value,
        isRefined: false,
        count: 0,
      }))
    );
  });

searchClient
  .searchForFacetValues([
    {
      indexName,
      params: {
        facetName: "category",
        facetQuery: "",
      },
    },
  ])
  .then(([{ facetHits }]) => {
    categoryFacet.push(
      ...facetHits.map((facet) => ({
        ...facet,
        label: facet.value,
        value: facet.value,
        isRefined: false,
        count: 0,
      }))
    );
  });

search.addWidgets([
  configure({
    attributesToSnippet: ["name:7", "description:15"],
    snippetEllipsisText: "…",
    hitsPerPage: 22,
    analytics: true,
    clickAnalytics: true,
  }),

  customHits({
    container: document.querySelector("#hits"),
    escapeHTML: false,
  }),

  // rangeInput({
  //     container: '#people-input',
  //     attribute: 'upper_capacity',
  // }),

  customRange({
    container: document.querySelector("#people-input"),
    attributes: { min: "lower_capacity", max: "upper_capacity" },
  }),

  stats({
    container: "#statsButton",
    templates: {
      text: `
            {{#areHitsSorted}}
                {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}
                {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}
                {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}
                sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
            {{/areHitsSorted}}
              {{^areHitsSorted}}
                {{#hasNoResults}}No results{{/hasNoResults}}
                {{#hasOneResult}}1 result{{/hasOneResult}}
                {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} listings{{/hasManyResults}}
              {{/areHitsSorted}}
            `,
    },
  }),

  stats({
    container: "#stats-button",
    templates: {
      text: `
            {{#areHitsSorted}}
                {{#hasNoSortedResults}}No relevant results{{/hasNoSortedResults}}
                {{#hasOneSortedResults}}1 relevant result{{/hasOneSortedResults}}
                {{#hasManySortedResults}}{{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results{{/hasManySortedResults}}
                sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
            {{/areHitsSorted}}
              {{^areHitsSorted}}
                {{#hasNoResults}}No results{{/hasNoResults}}
                {{#hasOneResult}}1 result{{/hasOneResult}}
                {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} listings{{/hasManyResults}}
              {{/areHitsSorted}}
            `,
    },
  }),

  customStats({
    container: document.querySelector("#stats"),
  }),

  customMenu({
    container: document.querySelector("#category-menu"),
    attribute: "category",
    transformItems: (items) => {
      categoryFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);

        if (updatedItem) {
          categoryFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      return uniqBy([...items, ...categoryFacet], "value");
    },
    limit: 100,
    sortBy: ["name"],
  }),

  refinementList({
    container: "#user-id-selection",
    attribute: "user_id",
    operator: "or",
  }),

  customMenuCategorySelect({
    container: document.querySelector("#categories"),
    attribute: "category",
    transformItems: (items) => {
      categoryFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);

        if (updatedItem) {
          categoryFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      return uniqBy([...items, ...categoryFacet], "value");
    },
    limit: 100,
    sortBy: ["name"],
  }),

  customMenuLocationSelect({
    container: document.querySelector("#regions"),
    attribute: "region",
    transformItems: (items) => {
      regionFacet.forEach((facet, index) => {
        const updatedItem = items.find((item) => item.value === facet.value);

        if (updatedItem) {
          regionFacet[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });
      return uniqBy([...items, ...regionFacet], "value");
    },
    limit: 100,
    sortBy: ["name"],
  }),

  customMenuLocationSelect({
    container: document.querySelector("#districts"),
    attribute: "district",
    limit: 100,
    sortBy: ["name"],
  }),

  customMenuLocationSelect({
    container: document.querySelector("#suburbs"),
    attribute: "suburb",
    limit: 100,
    sortBy: ["name"],
  }),

  customGeoSearch({
    container: document.querySelector("#map"),
    initialZoom: 5,
    initialPosition: {
      lat: -40.5182013,
      lng: 174.2751324,
    },
  }),

  customClearFilterRefinements({
    container: document.querySelector("#clear-filter-refinements"),
    includedAttributes: [
      "space_type",
      "amenities",
      "lower_capacity",
      "upper_capacity",
    ],
  }),

  customClearRegionRefinements({
    container: document.querySelector("#clear-refinements-region"),
    includedAttributes: ["region"],
  }),

  customClearDistrictRefinements({
    container: document.querySelector("#clear-refinements-district"),
    includedAttributes: ["district"],
  }),

  customClearSuburbRefinements({
    container: document.querySelector("#clear-refinements-suburb"),
    includedAttributes: ["suburb"],
  }),

  customClearTagRefinements({
    container: document.querySelector("#clear-refinements-tag"),
    includedAttributes: ["space_type"],
  }),

  customClearCapacityRefinements({
    container: document.querySelector("#clear-refinements-capacity"),
    includedAttributes: ["lower_capacity", "upper_capacity"],
  }),

  customClearAmenityRefinements({
    container: document.querySelector("#clear-refinements-amenity"),
    includedAttributes: ["amenities"],
  }),

  customCurrentRefinements({
    container: document.querySelector("#current-refinements"),
  }),

  customPagination({
    container: document.querySelector("#pagination"),
  }),

  customSearchBox({
    container: document.querySelector("#search-box"),
    placeholder: "Search for listings",
  }),
  customRefinementList({
    container: document.querySelector("#amenity"),
    attribute: "amenities",
    operator: "and",
    limit: 5,
    sortBy: ["name:asc"],
    showMore: true,
    showMoreLimit: 100,
  }),
  customRefinementList({
    container: document.querySelector("#tag"),
    attribute: "space_type",
    operator: "and",
    limit: 5,
    sortBy: ["name:asc"],
    showMore: true,
    showMoreLimit: 100,
  }),
  customTagRefinementList({
    container: document.querySelector("#tag-refine"),
    attribute: "space_type",
    limit: 7,
    sortBy: ["name:asc"],
    showMore: true,
    showMoreLimit: 100,
  }),

  customObjectIDRefinementList({
    container: document.querySelector("#object-id-refinement-list"),
    attribute: "id",
    searchable: true,
    limit: 100,
    showMore: false,
  }),
]);

// search.use(
//   createInsightsMiddleware({
//     insightsClient: window.aa,
//   })
// );

search.use(() => ({
  onStateChange({ uiState }) {
    sendEventDebounced(uiState);
  },
  subscribe() {},
  unsubscribe() {},
}));

search.on("render", function () {
  if (document.querySelector("#div-gpt-ad-1643764940109-0")) {
    googletag.cmd.push(function () {
      googletag.display("div-gpt-ad-1643764940109-0");
    });
  }

  if (document.querySelector("#div-gpt-ad-1643775030507-0")) {
    googletag.cmd.push(function () {
      googletag.display("div-gpt-ad-1643775030507-0");
    });
  }
});

window.aa(
  "setUserToken",
  document.querySelector("#identifier").firstChild.nodeValue
);

function checkMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  }

  return false;
}

function ajax(url) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      resolve(JSON.parse(this.responseText));
    };
    xhr.onerror = reject;
    xhr.open("GET", url);
    xhr.send();
  });
}

function uniqBy(items, property) {
  const seen = {};

  return items.filter((item) => {
    const val = item[property];

    if (seen[val]) {
      return false;
    } else {
      seen[val] = true;
      return true;
    }
  });
}
